import { useState } from 'react';

const usePagination = (fetchFunction) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPageData = async (page = 1) => {
        try {
            setLoading(true);
            setError(null);
            const response = await fetchFunction(page);
            setData(response.data);
            setTotalPages(response.last_page); 
            setCurrentPage(response.current_page);
        } catch (err) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        fetchPageData(page);
    };

    return {
        currentPage,
        totalPages,
        data,
        loading,
        error,
        handlePageChange,
        fetchPageData,
    };
};

export default usePagination;
